import React from 'react';
import {
  SvgIcon
} from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';




export default function ArrowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} className="icon-svg" sx={{ fontSize: '1.49rem', height: 'auto', display:"block !important"}}>

        <svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.1184 39.3716L2.64502 20.8982L21.1184 2.42481" stroke="#373873" stroke-width="4.61835" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    </SvgIcon>
  );
}
